import { createFileRoute } from '@tanstack/react-router';

import { VoicePlaygroundContent } from '@apps/web/routes/_app/admin/voice-playground/index.lazy';

export const Route = createFileRoute('/_app/admin/voice-playground/$call-id')({
    component: VoicePlaygroundCallIdPage,
    head: () => ({
        meta: [
            {
                title: 'Voice Playground | Phoebe',
            },
        ],
    }),
});

function VoicePlaygroundCallIdPage() {
    const { 'call-id': callId } = Route.useParams();
    return <VoicePlaygroundContent initialCallId={callId} />;
}
